import { z } from 'zod';

export const ClinicsPackageSelectionSchema = z.object({
   package_name: z.string().min(1, 'Package name is required'),
   consultation_fee_from: z.number(),
   consultation_fee_to: z.number(),
   package_price: z.coerce.number().min(0, 'Package price is cannot be negative'),
   priceOption: z.string(),
   description: z.string().trim().min(1, 'Description is required'),
   consultation_decided: z.boolean(),
   isFreeConsultation: z.boolean(),
});
// .superRefine((data, ctx) => {
//   if (!data.isFreeConsultation) {
//     if (!data.consultation_fee_from) {
//       ctx.addIssue({
//         path: ["consultation_fee_from"],
//         code: z.ZodIssueCode.custom,
//         message: "Consultation fee from is required",
//       });
//     }
//     if (!data.consultation_fee_to) {
//       ctx.addIssue({
//         path: ["consultation_fee_to"],
//         code: z.ZodIssueCode.custom,
//         message: "Consultation fee to is required",
//       });
//     }
//   }
// });

export type TClinicsPackageSelection = z.infer<typeof ClinicsPackageSelectionSchema>;
